

import { createApiClient } from 'Network/ApiClient';

export const BenefitAxiosInstance = createApiClient('Benefit/');


